import React from "react";
// import { find } from "lodash";
// import AssessmentWarnings from "../../pages/assessment/assessmentWarnings";
import SpeakQuestionSvg from "./SpeakQuestionSvg";
import { useMobileView } from "./MobileViewContext";
const SectionBar = ({
  section_number,
  data,
  answers,
  standing_page,
  section,
  isLastIndex,
}) => {
  let { isMobileView } = useMobileView();
  let section_status = "inactive";
  let class_name = "text-secondary";
  let ques_class_name = "text-black";
  // let assessment_warnings = AssessmentWarnings(data, answers);
  // let get_current_section;
  // assessment_warnings &&
  //   assessment_warnings.forEach((assessment_warning) => {
  //     if (assessment_warning.section_number === section_number) {
  //       get_current_section = assessment_warning;
  //     }
  //   });
  if (true) {
    // if (!get_current_section) {
    //   section_status = "completed";
    //   class_name = "active_question";
    //   ques_class_name = "active_question";
    // }
    if (parseInt(`${section_number}`) < standing_page) {
      section_status = "completed";
      class_name = "active_question";
      ques_class_name = "active_question";
    }
  }
  if (standing_page === parseInt(`${section_number}`)) {
    section_status = "active";
    class_name = "active_question";
    ques_class_name = "active_question";
  }
  return (
    <div className="d-flex">
      {isMobileView ? (
        <SpeakQuestionSvg
          section_status={section_status}
          isLastIndex={isLastIndex}
        />
      ) : (
        <>
          <SpeakQuestionSvg
            section_status={section_status}
            isLastIndex={isLastIndex}
          />
          <div className="ps-3">
            <p className={`fw-600 ${ques_class_name}`}>
              {section.section_name}
            </p>
            <div
              className={`${class_name}`}
              spellcheck="false"
              data-gramm="false"
            >
              {section.section_title}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SectionBar;
